// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { viewSelectStyles } from "@guestsupply/Overrides/Widgets/ProductList/ProductListViewSelect";
import Grid from "@guestsupply/XDL/Icons/Grid";
import List from "@guestsupply/XDL/Icons/List";
import Table from "@insite/mobius/Icons/Table";
import { css } from "styled-components";

viewSelectStyles.wrapper = {
    css: css`
        display: flex;
        float: right;
    `,
};
viewSelectStyles.listViewClickable = {
    css: css`
        margin-left: 12px;
    `,
};
viewSelectStyles.gridViewClickable = {
    css: css`
        margin-left: 12px;
    `,
};
viewSelectStyles.listViewIcon = {
    src: List,
    size: 21,
    css: css`
        &,
        & > svg {
            height: 17px;
        }
        &:hover,
        &:focus {
            opacity: 0.66;
        }
    `,
};
viewSelectStyles.gridViewIcon = {
    src: Grid,
    size: 21,
    css: css`
        height: 18px;
        & > svg {
            height: 18px;
        }
        &:hover,
        &:focus {
            opacity: 0.66;
        }
    `,
};
viewSelectStyles.tableViewIcon = {
    src: Table,
    size: 26,
};
